import { Divider, Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { type AsynchronousJobVariant, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportScheduledAppointment: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportScheduledAppointment),
    payload: z.object({
      patientFirstName: RequiredStringSchema,
      patientLastName: RequiredStringSchema,
      patientDateOfBirth: RequiredStringSchema,
      appointmentForm: z
        .object({
          formSetId: RequiredStringSchema,
          fields: z.union(
            [
              z.array(
                z.object({
                  value: RequiredStringSchema,
                  fieldName: RequiredStringSchema,
                  primitive: RequiredStringSchema,
                })
              ),
              RequiredStringSchema,
            ],
            {
              message: 'Required',
            }
          ),
        })
        .required(),
      orderName: RequiredStringSchema,
      appointmentStartTime: RequiredStringSchema,
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.patientFirstName"
          label="Patient First Name"
          helperText="Enter the reference to the patient's first name. e.g. `{{patient.data.firstName}}`"
          placeholder="e.g. {{patient.data.firstName}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientLastName"
          label="Patient Last Name"
          helperText="Enter the reference to the patient's last name. e.g. `{{patient.data.lastName}}`"
          placeholder="e.g. {{patient.data.lastName}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.patientDateOfBirth"
          label="Patient Date of Birth"
          helperText="Enter the reference to the patient's date of birth. e.g. `{{patient.data.dateOfBirth}}`"
          placeholder="e.g. {{patient.data.dateOfBirth}}"
        />
        <Divider />
        <BlockValueTemplateField
          fieldName="config.payload.appointmentForm.formSetId"
          label="Form Set Id"
          helperText="Enter the reference to the Appointment Form Set Id. e.g. `{{form.data.formSetId}}`"
          placeholder="e.g. {{form.data.formSetId}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.appointmentForm.fields"
          label="Form Fields"
          helperText="Enter the reference to the Appointment Form Fields. e.g. `{{form.data.fields}}`"
          placeholder="e.g. {{form.data.fields}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.orderName"
          label="Order Name"
          helperText="Enter the reference to the Order Name. e.g. `{{form.data.orderName}}`"
          placeholder="e.g. {{form.data.orderName}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.appointmentStartTime"
          label="Appointment Start Time"
          helperText="Enter the reference to the Appointment Start Time. e.g. `{{form.data.appointmentStartTime}}`"
          placeholder="e.g. {{form.data.appointmentStartTime}}"
        />
      </Stack>
    );
  },
};
